export const isPortrait = () => {
    /*const screen = 'screen' in window && window.screen ? <any> window.screen : null;
    if (screen && screen.orientation) {
        return ['portrait-primary', 'portrait-secondary'].indexOf(screen.orientation.type) !== -1;
    }*/

    return window.innerWidth <= window.innerHeight;
};